import { render, staticRenderFns } from "./documentContent.vue?vue&type=template&id=e6a3748e&scoped=true&"
import script from "./documentContent.vue?vue&type=script&lang=js&"
export * from "./documentContent.vue?vue&type=script&lang=js&"
import style0 from "./documentContent.vue?vue&type=style&index=0&id=e6a3748e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a3748e",
  null
  
)

export default component.exports